module.exports = __webpack_public_path__ + "media/images/bird-e0086440e1acf40b9371af7c03044343.png";